export const countryPhoneMasks: { [key: string]: string } = {
  '+1': '(999) 999-9999', // USA
  '+33': '99 99 99 99 99', // France
  '+43': '(999) 999 9999', // Austria
  '+44': '9999 999 9999', // UK
  '+49': '(999) 999999', // Germany
  '+54': '(999) 999-9999', // Argentina
  '+55': '(99) 99999-9999', // Brazil
  '+81': '(99) 9999-9999', // Japan
  '+86': '999 9999 9999', // China
  '+358': '999 9999999', // Finland
  '+972': '999-999-9999', // Israel
};

export const countryPhoneRegex: { [key: string]: RegExp } = {
  '+1': /^\(\d{3}\) \d{3}-\d{4}$/, // USA
  '+33': /^\d{2} \d{2} \d{2} \d{2} \d{2}$/, // France
  '+43': /^\(\d{3}\) \d{3} \d{4}$/, // Austria
  '+44': /^\d{4} \d{3} \d{4}$/, // UK
  '+49': /^\(\d{3}\) \d{6}$/, // Germany
  '+54': /^\(\d{3}\) \d{3}-\d{4}$/, // Argentina
  '+55': /^\(\d{2}\) \d{5}-\d{4}$/, // Brazil
  '+81': /^\(\d{2}\) \d{4}-\d{4}$/, // Japan
  '+86': /^\d{3} \d{4} \d{4}$/, // China
  '+358': /^\d{3} \d{7}$/, // Finland
  '+972': /^\d{3}-\d{3}-\d{4}$/, // Israel
};
